import { IconProps } from './types';

export const ShareIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21.456 23.691'>
    <path
      // eslint-disable-next-line max-len
      d='M22.37,19.88a3.257,3.257,0,0,0-2.331.893l-8.547-4.941a4,4,0,0,0,.12-.834,4,4,0,0,0-.12-.834L19.92,9.285a3.577,3.577,0,1,0-1.136-2.619,3.979,3.979,0,0,0,.12.834L10.477,12.38a3.6,3.6,0,0,0-2.45-.952A3.539,3.539,0,0,0,4.5,15a3.6,3.6,0,0,0,6.037,2.619l8.487,4.941a2.986,2.986,0,0,0-.12.774A3.466,3.466,0,1,0,22.37,19.88Z'
      transform='translate(-4.5 -3.094)'
      fill='#fff'
      {...props}
    />
  </svg>
);
